import React, { useEffect, useState } from 'react'
import Select from '../../../components/Select/Select'
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Button from "@mui/material/Button";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Axios from "axios";
import { API_URL_USER, API_URL_ADMIN, API_URL_VPS, API_URL_OMS, API_URL_AMS } from "../../../Constant/index";


const UsersRoles = () => {
    const adminUsers = ["ADMIN_USER 1", "ADMIN_USER 2", "ADMIN_USER 3", "ADMIN_USER 4", "ADMIN_USER 5"]
    const roles = ["Select", "SCCC - CIPI Admin", "SCCC - WeCare Support", "SCCC - CSC Support", "SCCC - Loyalty Admin", "SCCC - Logistic Admin", "SCCC - CCAR Admin", "SCCC - Pricing Admin", "SCCC - Analyst Admin", "SCCC - Sales Co Admin", "CW - CSC Support", "CW - Pricing Admin", "CW - Sales Co Admin", "SCCO - Admin"]
    // const users = ["User 1", "User 2", "User 3", "User 4", "User 5", "User 6", "User 7", "User 8", "User 9", "User 10"]
    const [userResponse, setUserResponse] = useState([]);
    const [role, setRole] = useState("SCCC - CIPI Admin");

    const roleOnChange = (e) => {
        setRole(e.target.value);
        Axios({
            method: "GET",
            url: API_URL_USER + `ums/resources/role-users?role=${e.target.value}`,
            headers: {
                "Content-Type": "application/json",
                "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
                "X-SOLD-TO-ID": "ADMIN USER",
            },
        })
            .then(async (response) => {
                setUserResponse(response.data)
            })
            .catch((err) => {
                // setExportState({ btnName: "EXPORT" });
            });
    };

    useEffect(() => {
        Axios({
            method: "GET",
            url: API_URL_USER + `ums/resources/role-users?role=` + "SCCC - CIPI Admin",
            headers: {
                "Content-Type": "application/json",
                "X-AUTH-TOKEN": localStorage.getItem("x-auth-token"),
                "X-SOLD-TO-ID": "ADMIN USER",
            },
        })
            .then(async (response) => {
                setUserResponse(response.data)
            })
            .catch((err) => {
                // setExportState({ btnName: "EXPORT" });
            });

    }, [])

    return (
        <div className='card mt-2'>
            <div className='row p-2'>
                <div className='col-12 col-sm-6 col-md-4'>
                    <Select
                        label={"Select Roles"}
                        options={roles}
                        minWidth="100%"
                        name="roles"
                        value={role}
                        onChange={roleOnChange}
                    />
                </div>
            </div>

            <div className='row p-2'>
                <div className='col-12'>
                    Users
                </div>
            </div>

            <div className='row p-2'>
                {userResponse && userResponse.length > 0 ?
                    <>
                        {
                            userResponse.map((item, index) =>
                                <div className='col-12 col-sm-6 col-md-3'>
                                    <p className={`border rounded p-1 ${index % 2 === 0 ? "bg-light" : ""}`}>
                                        {item.permission}
                                    </p>
                                </div>
                            )
                        }
                    </>
                    :
                    <div className='col-12'>
                        <p className='text-center'>
                            No Users assigned
                        </p>
                    </div>
                }


            </div>

            {/* <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="female"
                name="radio-buttons-group"
            >
                <div className='card p-3 mt-2'>

                    <div className='row'>
                        <div className='col-sm-6 col-md-3 col-lg-3'>
                            <FormControlLabel value="CIPI ADMIN" control={<Radio />} label="CIPI ADMIN" />
                        </div>

                        <div className='col-sm-6 col-md-3 col-lg-3'>
                            <FormControlLabel value="WE CARE SUPPORT" control={<Radio />} label="WE CARE SUPPORT" />
                        </div>


                        <div className='col-sm-6 col-md-3 col-lg-3'>
                            <FormControlLabel value="CSC Support" control={<Radio />} label="CSC Support" />
                        </div>


                        <div className='col-sm-6 col-md-3 col-lg-3'>
                            <FormControlLabel value="Others" control={<Radio />} label="Others" />
                        </div>

                        <div className='col-sm-6 col-md-3 col-lg-3'>
                            <FormControlLabel value="Others 2" control={<Radio />} label="Others 2" />
                        </div>

                        <div className='col-sm-6 col-md-3 col-lg-3'>
                            <FormControlLabel value="Others 3" control={<Radio />} label="Others 3" />
                        </div>

                        <div className='col-sm-6 col-md-3 col-lg-3'>
                            <FormControlLabel value="Others 4" control={<Radio />} label="Others 4" />
                        </div>


                        <div className='col-12 text-right'>
                            <Button
                                variant="contained"
                                className="btncolor px-5"
                                size="small"
                                sx={{ m: 1 }}
                            //   onClick={}
                            >
                                Update
                            </Button>
                        </div>

                    </div>
                </div>
            </RadioGroup> */}

        </div >
    )
}

export default UsersRoles